module.exports = __webpack_public_path__ + "img/type_performer@2x.682cdc4c.png";